import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAE: CultureInfo = {
  name: 'en-AE',
  displayName: 'English (United Arab Emirates)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AE',
  parent: CultureInfoEn
};
